import React, { useEffect, useMemo, useState } from "react";
import {
  Box, Card, CardContent, Typography, Stack, Button, IconButton, Chip,
  Avatar, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions,
  Snackbar, Alert, Divider, LinearProgress, TextField, InputAdornment,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { LoadingButton } from "@mui/lab";
import Autocomplete from "@mui/material/Autocomplete";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import axios from "axios";

import SelectAllIcon from "@mui/icons-material/SelectAll";
import { SupervisorUid } from "../components/constants";


// same URL helper used everywhere else in the app
const normalizeBaseUrl = (raw) => {
  if (!raw) return "";
  const trimmed = raw.trim().replace(/\/$/, "");
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export default function VisitSupervisorPage() {
    const base = useMemo(
        () => normalizeBaseUrl(localStorage.getItem("saved_sett_api_url") || ""),
        [],
    );

    const [employees, setEmployees] = useState([]);   // full employee list, for both columns of the picker
    //const [assignments, setAssignments] = useState([]); // raw rows from /api/visit/supervisors
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMode, setDialogMode] = useState("create");
    // const [selectedEmployee, setSelectedEmployee]=useState(null); // single employee being configured
    const [selectedEmployees, setSelectedEmployees] = useState([]); // array now, not single object
    const [selectedSupervisors, setSelectedSupervisors]=useState([]); // ordered array, top = priority 1
    const [saving,setSaving]=useState(false);

    const [formError, setFormError] = useState("");
    const [deleting, setDeleting] = useState(false);

    const [confirmOpen, setConfirmOpen]= useState(false);
    // const [deletingEmpId, setDeletingEmpId]= useState(null);
    // const [deletingEmpIds, setDeletingEmpIds] = useState([]);

    // const [originalEditEmpIds, setOriginalEditEmpIds] = useState([]);
    const [deletingRole, setDeletingRole] = useState(null);

    const [visitName, setVisitName] = useState("");
    const [editingCode, setEditingCode] = useState(null);

    // Esclation delay for supervisor 
    const [supervisorAfterDays, setSupervisorAfterDays] = useState({});


     const supervisorUidSet = useMemo(                                   // add
         () => new Set(SupervisorUid.map((u) => String(u).trim())),        // add
         [],                                                               //  add
       );                                                                  //  add
       const assignableEmployees = useMemo(                                //  add
         () => employees.filter((e) => !supervisorUidSet.has(String(e.empid))), //  add
         [employees, supervisorUidSet],                                    //  add
       ); 

       //Filter by visit Name 

    const empSearchLabel = (e) => {
      if (!e) return "";
      return e.code ? `${e.code} - ${e.name}` : e.name;
    };

    const filterByNameOrCode = (options, state) => {
      const q = String(state.inputValue ?? "").trim().toLowerCase();
      if (!q) return options;
      return options.filter((o) => {
        const name = String(o.name).toLowerCase();
        const code = String(o.code).toLowerCase();
        const id = String(o.empid);
        return name.includes(q) || code.includes(q) || id.includes(q) || `${code} ${name}`.includes(q);
      });
    };

    

    //up/down arrow buttons that reorder supervisors in priority list 
    //swap two items in an array — same reorder helper as LeaveRolesPage
    const swap = (arr, i, j) => {
        //if 2 positions equal , out of bounds return the arrafy  unchanged ! 
    if (i === j || i < 0 || j < 0 || i >= arr.length || j >= arr.length) return arr;
    //.slice() with no arguments copies the whole array, so we can freely modify the copy without touching the original array 
    const copy = arr.slice();
    [copy[i], copy[j]] = [copy[j], copy[i]];
    return copy;
    };

    const moveSupUp = (index) => setSelectedSupervisors((prev) => swap(prev, index, index - 1));
    const moveSupDown = (index) => setSelectedSupervisors((prev) => swap(prev, index, index + 1));



    const closeDialog = () => {
      setDialogOpen(false);
      setSelectedEmployees([]);
      setSelectedSupervisors([]);
      setSupervisorAfterDays({});
      setVisitName("");
      setEditingCode(null);
      setFormError("");
    };

    const openCreate = () => {
      setDialogMode("create");
      setSelectedEmployees([]);
      setSelectedSupervisors([]);
      setSupervisorAfterDays({});
      setVisitName("");
      setEditingCode(null);
      setFormError("");
      setDialogOpen(true);
    };

    const openEdit = (row) => {
      setDialogMode("edit");
      setFormError("");
      setEditingCode(row.visitCode);
      setVisitName(row.visitName || "");
      setSelectedEmployees(row.empIds.map((id) => empById(id) || { empid: id, name: empLabel(id) }));
      setSelectedSupervisors(
        row.supervisors.map((s) => empById(s.supervisorId) || { empid: s.supervisorId, name: empLabel(s.supervisorId) })
      );
      const seededAfterDays = {};
      row.supervisors.forEach((s) => {
        seededAfterDays[s.supervisorId] = Number(s.afterDays) || 0;
      });
      setSupervisorAfterDays(seededAfterDays);
      setDialogOpen(true);
    };

    // const closeDialog = () => {
    //   setDialogOpen(false);
    //   setSelectedEmployees([]);
    //   setSelectedSupervisors([]);
    //   setOriginalEditEmpIds([]);   // ← add
    //   setSupervisorAfterDays({});
    // };

  // const openCreate = () => {
  //   setDialogMode("create");
  //   setSelectedEmployees([]);
  //   setSelectedSupervisors([]);
  //   setOriginalEditEmpIds([]);   // ← add
  //   setSupervisorAfterDays({});
  //   setDialogOpen(true);
  // };

  // const openEdit = (row) => {
  //   setDialogMode("edit");
  //   const emps = row.empIds.map((id) => empById(id) || { empid: id, name: empLabel(id) });
  //   setSelectedEmployees(emps);
  //   setOriginalEditEmpIds(row.empIds); // ← NEW: remember who was originally in this group
  //   setSelectedSupervisors(
  //     row.supervisors.map((s) => empById(s.supervisorId) || { empid: s.supervisorId, name: empLabel(s.supervisorId) })
  //   );
  //   const seededAfterDays = {};
  //   row.supervisors.forEach((s) => {
  //     seededAfterDays[s.supervisorId] = Number(s.afterDays) || 0;
  //   });
  //   setSupervisorAfterDays(seededAfterDays);
  //   setDialogOpen(true);
  // };

// 1 name + n names when select multiple employess or supervisors 
    const firstOnly = (full = "") => full.split(" ").filter(Boolean)[0] || full;
    
    // here are the 3 columns to draw, and for each one, 
    // here's custom JSX to render instead of showing raw data" — params.
    // row is always the full grouped-row object ({id, empId, supervisors}) 
    // for whichever row is currently being drawn.

    const columns = [
        {
          field: "visitName",
          headerName: "Visit role",
          headerAlign: "center",
          align: "center",
          flex: 1.1,
          minWidth: 180,
          renderCell: (params) => (
            <Chip
              label={params.row.visitName}
              sx={{ bgcolor: "#00897B20", color: "#00897B", fontWeight: 700, borderRadius: 1.5 }}
            />
          ),
        },

        {
          field: "empIds",
          headerName: "Assigned employees",
          headerAlign: "center",   // ← built-in prop, no CSS fighting needed
          align: "center", 
          flex: 1,
          minWidth: 220,
          sortable: false,
          renderCell: (params) => {
              const names = params.row.empIds.map((id) => empLabel(id));
              const first = firstOnly(names[0]);

              return (
                  <Tooltip
                      title={
                          <React.Fragment>
                              {names.map((n, i) => (
                                  <div key={i}>{n}</div>
                              ))}
                          </React.Fragment>
                      }
                      arrow
                  >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Chip label={first} size="small" />
                          {names.length > 1 && (
                              <Chip label={`+${names.length - 1} more`} size="small" variant="outlined" />
                          )}
                      </Stack>
                  </Tooltip>
              );
          },
      },  

        {
        field: "supervisors",
        headerName: "Supervisor chain (priority order)",
        headerAlign: "center",   // ← built-in prop, no CSS fighting needed
        align: "center", 
        flex: 1.6,
        minWidth: 260,
        sortable: false,
        renderCell: (params) => {
            const sups = params.row.supervisors;
            if (!sups.length) {
              return (
                  <Typography variant="body2" color="text.secondary">
                      —
                  </Typography>
              );
          }

            const names = sups.map((s, idx) => `${idx + 1}. ${empLabel(s.supervisorId)}`);
            const first = firstOnly(empLabel(sups[0].supervisorId));

            return (
                <Tooltip
                    title={
                        <React.Fragment>
                            {names.map((n, i) => (
                                <div key={i}>{n}</div>
                            ))}
                        </React.Fragment>
                    }
                    arrow
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip label={`1. ${first}`} size="small" />
                        {names.length > 1 && (
                            <Chip label={`+${names.length - 1} more`} size="small" variant="outlined" />
                        )}
                    </Stack>
                </Tooltip>
            );
        },
    },
        {
            field: "actions",
            headerName: "Actions",
            headerAlign: "center",   // ← built-in prop, no CSS fighting needed
            align: "center", 
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
            <Stack direction="row" spacing={0.5}>
                <Tooltip title="Edit">
                <IconButton size="small" onClick={() => openEdit(params.row)}>
                    <EditRoundedIcon fontSize="small" />
                </IconButton>
                </Tooltip>
                <Tooltip title="Remove all">
                <IconButton
                    size="small"
                    color="error"
                    onClick={() => { setDeletingRole(params.row); setConfirmOpen(true); }}      
                    //onClick={() => { setDeletingEmpIds(params.row.empIds); setConfirmOpen(true); }}
                >
                    <DeleteRoundedIcon fontSize="small" />
                </IconButton>
                </Tooltip>
            </Stack>
            ),
        },
        ];

    //convert id into names 
    // one employee lookup by id, so we can turn a raw EmpId into a display name
    const empById = (id) => employees.find((e) => Number(e.empid) === Number(id));
    const empLabel = (id) => empById(id)?.name || String(id);

    // pull the raw employee-supervisor pairs, and the employee list for names
    const fetchAll = async () => {
        if (!base){
            setLoading(false);
            setSnack({open :true, message:"API URL not set in Settings.", severity:"error"});
            return;
        }
        setLoading(true);
        try {
            const [supRes, empRes]= await Promise.all([
                axios.get(`${base}/api/visit/roles`),
                axios.get(`${base}/api/employees`)
            ]);
            //Axios wraps the actual server response inside a .data
            const empPayload = empRes?.data;
            //if any error fallback into an empty array 
            const empList = Array.isArray(empPayload) ? empPayload
                : Array.isArray(empPayload?.data) ? empPayload.data
                : [];
            //real array empList,normalized into a consistent shape: always {empid, code, name}
            //convert whatever string or number 
            setEmployees(
                empList.map((x) => ({
                empid: Number(x.empid ?? x.EmpId ?? x.empId ?? 0),
                code: String(x.code ?? x.EmpCode ?? ""),
                name: String(x.name ?? x.fullName ?? "").trim(),
                })).filter((e) => e.empid && e.name)  // show up as a blank employee in the picker.
            );
            
            //always returns a plain array (from get_visit_supervisors()
            //setAssignments(Array.isArray(supRes.data) ? supRes.data : []);
            setRoles(Array.isArray(supRes.data) ? supRes.data : []);
            } catch (e) {
            setSnack({ open: true, message: "Failed to load supervisor assignments.", severity: "error" });
            } finally {
            setLoading(false);
            }
        };

        useEffect(() => {
          fetchAll();
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      // group the flat list of {entryNo, supervisorId, empId} rows into
      // one row per EMPLOYEE, with their supervisors already sorted by priority
     // group by IDENTICAL supervisor chain (same supervisors, same order),
    // so employees sharing one chain collapse into a single row

    const groupedRows = useMemo(
      () => roles.map((r) => ({
        id: r.visitCode,
        visitCode: r.visitCode,
        visitName: r.visitName,
        empIds: r.empIds || [],
        supervisors: r.supervisors || [],
      })),
      [roles],
    );
    // const groupedRows = useMemo(() => {
    //   const byEmp = {};
    //   assignments.forEach((a) => {
    //     if (!byEmp[a.empId]) byEmp[a.empId] = [];
    //     byEmp[a.empId].push(a);
    //   });

    //   // each employee's chain, sorted by priority
    //   const employeeChains = Object.entries(byEmp).map(([empId, sups]) => ({
    //     empId: Number(empId),
    //     supervisors: sups.slice().sort((a, b) => (a.priority ?? 1) - (b.priority ?? 1)),
    //   }));

    //   // build a signature string for each chain so identical chains group together
    //   // e.g. "9009-1,1178-2" — supervisorId-priority pairs, in order
    //   const chainKey = (supervisors) =>
    //     supervisors.map((s) => `${s.supervisorId}-${s.priority ?? 1}`).join(",");

    //   const byChain = {};
    //   employeeChains.forEach((ec) => {
    //     const key = chainKey(ec.supervisors);
    //     if (!byChain[key]) {
    //       byChain[key] = { supervisors: ec.supervisors, empIds: [] };
    //     }
    //     byChain[key].empIds.push(ec.empId);
    //   });

    //   // turn each unique chain into one row
    //   return Object.values(byChain).map((group, idx) => ({
    //     id: idx,                        // unique row id (index is fine here, chains are unique per row)
    //     empIds: group.empIds,           // ← array now, not a single empId
    //     supervisors: group.supervisors,
    //   }));
    // }, [assignments]);

    // simple text filter on employee name/code
    const filteredRows = useMemo(() => {
      const q = search.trim().toLowerCase();
      if (!q) return groupedRows;
      return groupedRows.filter((r) =>
        (r.visitName || "").toLowerCase().includes(q) ||
        r.empIds.some((id) => empLabel(id).toLowerCase().includes(q)) ||
        r.supervisors.some((s) => empLabel(s.supervisorId).toLowerCase().includes(q))
    );
  }, [groupedRows, search, employees]);

//Sync visit_supervisor between local and remote 

  // const syncVisitSupervisors = async () => {
  //   try {
  //     await axios.get(`${base}/api/visit-supervisor/sync`, { withCredentials: true });
  //   } catch {
  //     setSnack({ open: true, message: "Saved locally, but sync to cloud failed.", severity: "warning" });
  //   }
  // };
  
    const syncVisitRoles = async () => {
    try {
      await axios.get(`${base}/api/visit-supervisor/sync`, { withCredentials: true });
    } catch {
      setSnack({ open: true, message: "Saved locally, but sync to cloud failed.", severity: "warning" });
    }
  };
 
  // ---- Save: turns the dialog's selection into supervisor assignments ----
    const saveAssignment = async () => {
    if (!visitName.trim()) {
      setFormError("Visit role name is required.");
      return;
    }
    if (!selectedEmployees.length) {
      setFormError("Select at least one employee.");
      return;
    }
    if (!selectedSupervisors.length) {
      setFormError("Add at least one supervisor.");
      return;
    }

    setFormError("");
    setSaving(true);
    try {
      await axios.post(`${base}/api/visit/roles`, {
        visitCode: editingCode,
        visitName: visitName.trim(),
        empIds: selectedEmployees.map((e) => e.empid),
        supervisors: selectedSupervisors.map((s) => ({
          supervisorId: s.empid,
          afterDays: Number(supervisorAfterDays[s.empid]) || 0,
        })),
      });
      setSnack({
        open: true,
        message: dialogMode === "create" ? "Visit role created." : "Visit role updated.",
        severity: "success",
      });
      closeDialog();
      await fetchAll();
      await syncVisitRoles();
    } catch (e) {
      const conflicts = e.response?.data?.conflicts;
      if (Array.isArray(conflicts) && conflicts.length) {
        const text = conflicts.map((c) => `${empLabel(c.empId)} (${c.visitName})`).join(", ");
        setFormError(`Already in another visit role: ${text}. Remove them from that role first.`);
      } else {
        setFormError(e.response?.data?.error || "Save failed. Please try again.");
      }
    } finally {
      setSaving(false);
    }
  };

  // const saveAssignment = async () => {
  //   if (!selectedEmployees.length) {
  //     setSnack({ open: true, message: "Please select at least one employee.", severity: "error" });
  //     return;
  //   }
  //   if (!selectedSupervisors.length) {
  //     setSnack({ open: true, message: "Add at least one supervisor.", severity: "error" });
  //     return;
  //   }

  //   setSaving(true);
  //   const failures = [];

    
  //   try {
  //     // NEW: anyone originally in this group but no longer selected gets their chain removed entirely
  //     if (dialogMode === "edit") {
  //       const currentIds = selectedEmployees.map((e) => e.empid);
  //       const removedIds = originalEditEmpIds.filter((id) => !currentIds.includes(id));
  //       for (const empId of removedIds) {
  //         const empAssignments = assignments.filter((a) => a.empId === empId);
  //         await Promise.all(
  //           empAssignments.map((a) => axios.post(`${base}/api/visit/supervisors/${a.entryNo}/supersede`))
  //         );
  //       }
  //     }

  //     for (const emp of selectedEmployees) {
  //       // ALWAYS supersede this employee's existing assignments first,
  //       // regardless of create vs edit mode. Skipping this in "create"
  //       // mode was the actual bug: picking an employee who ALREADY had
  //       // a supervisor assigned, via "New assignment" instead of
  //       // "Edit", left the old row active AND added a new one — both
  //       // landing on Priority 1, so the priority chain was never
  //       // really enforced (whichever row is Priority 1 can always act).
  //       const empAssignments = assignments.filter((a) => a.empId === emp.empid);
  //       if (empAssignments.length) {
  //         await Promise.all(
  //           empAssignments.map((a) => axios.post(`${base}/api/visit/supervisors/${a.entryNo}/supersede`))
  //         );
  //       }

  //       for (let idx = 0; idx < selectedSupervisors.length; idx++) {
  //         const sup = selectedSupervisors[idx];
  //         try {
  //           await axios.post(`${base}/api/visit/supervisors`, {
  //             empId: emp.empid,
  //             supervisorId: sup.empid,
  //             priority: idx + 1,
  //             afterDays: Number(supervisorAfterDays[sup.empid]) || 0,
  //           });
  //         } catch (e) {
  //           failures.push(`${emp.name} → ${sup.name}`);
  //         }
  //       }
  //     }

  //     if (failures.length) {
  //       setSnack({ open: true, message: `Saved, but some assignments already existed and were skipped: ${failures.join(", ")}`, severity: "warning" });
  //     } else {
  //       setSnack({ open: true, message: `Supervisor chain saved for ${selectedEmployees.length} employee(s).`, severity: "success" });
  //     }
  //     closeDialog();
  //     await fetchAll();
  //     await syncVisitSupervisors();
  //   } catch (e) {
  //     setSnack({ open: true, message: "Save failed.", severity: "error" });
  //   } finally {
  //     setSaving(false);
  //   }
  // };

  // ---- Delete: removes ALL of one employee's supervisor rows ----
  const confirmDelete = async () => {
    if (!deletingRole) { setConfirmOpen(false); return; }
    setDeleting(true);
    try {
      await axios.delete(`${base}/api/visit/roles/${deletingRole.visitCode}`);
      setSnack({ open: true, message: "Visit role deleted.", severity: "success" });
      await fetchAll();
      await syncVisitRoles();
    } catch {
      setSnack({ open: true, message: "Delete failed.", severity: "error" });
    } finally {
      setDeleting(false);
      setDeletingRole(null);
      setConfirmOpen(false);
    }
  };

//   const confirmDelete = async () => {
//   if (!deletingEmpIds.length) { setConfirmOpen(false); return; }
//   try {
//     for (const empId of deletingEmpIds) {
//       const empAssignments = assignments.filter((a) => a.empId === empId);
//       await Promise.all(
//         empAssignments.map((a) => axios.delete(`${base}/api/visit/supervisors/${a.entryNo}`))
//       );
//     }
//     setSnack({ open: true, message: "Assignments removed.", severity: "success" });
//     await fetchAll();
//     await syncVisitSupervisors();
//   } catch {
//     setSnack({ open: true, message: "Delete failed.", severity: "error" });
//   } finally {
//     setDeletingEmpIds([]);
//     setConfirmOpen(false);
//   }
// };

    const NoRows = () => (
    <Stack height="100%" alignItems="center" justifyContent="center" spacing={1.5}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#004d40" }}>
        No visit roles
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Create a visit role to choose who approves each employee's visits.
      </Typography>
      <Button onClick={openCreate} variant="contained" startIcon={<AddRoundedIcon />} sx={{ borderRadius: 2 }}>
        Add visit role
      </Button>
    </Stack>
  );

  const renderPickerOption = (props, option) => (
    <li {...props} key={option.empid}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Chip size="small" label={option.code || option.empid} sx={{ borderRadius: 2 }} />
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {option.name}
        </Typography>
      </Stack>
    </li>
  );
 
return (
  <Box
    sx={{
      minHeight: "100vh",
      p: { xs: 2, md: 3 },
      display: "flex",
      justifyContent: "center",
      background: `radial-gradient(1200px 600px at -10% -20%, rgba(0,121,107,0.18), transparent 60%),
                   radial-gradient(900px 500px at 120% 120%, rgba(0,151,167,0.16), transparent 60%),
                   linear-gradient(135deg, #e0f2f1 0%, #ffffff 60%)`,
    }}
  >
    <Card
      elevation={0}
      sx={{
        width: 1100,
        maxWidth: "98vw",
        borderRadius: 4,
        overflow: "hidden",
        backdropFilter: "blur(10px)",
        bgcolor: "rgba(255,255,255,0.96)",
        boxShadow: "0 10px 30px rgba(0,0,0,.08), 0 20px 60px rgba(0,121,107,.15)",
        border: "1px solid",
        borderColor: "#b2dfdb",
      }}
    >
      {loading && <LinearProgress color="success" sx={{ borderRadius: "4px 4px 0 0" }} />}

      <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "start", sm: "center" }}
          justifyContent="space-between"
          gap={2}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar sx={{ bgcolor: "#00838f", width: 56, height: 56, boxShadow: "0 8px 24px rgba(0,131,143,.30)" }}>
              <NotificationsActiveRoundedIcon fontSize="medium" />
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 800, color: "#004d40" }}>
                Visit Roles
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Define who approves each employee's visits, in priority order.
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={1.5} alignItems="center">
            <TextField
              size="small"
              placeholder="Search visit roles…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchRoundedIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: 220 }}
            />
            <Button
              variant="outlined"
              onClick={fetchAll}
              startIcon={<InfoOutlinedIcon />}
              sx={{ borderRadius: 2 }}
            >
              Refresh
            </Button>

            <Button
              variant="contained"
              onClick={openCreate}
              startIcon={<AddRoundedIcon />}
              sx={{ borderRadius: 2, bgcolor: "#004d40", ":hover": { bgcolor: "#003d33" }, boxShadow: "0 10px 24px rgba(0,77,64,.25)" }}
            >
              New visit role
            </Button>
          </Stack>
        </Stack>

        <Divider sx={{ my: 2.5 }} />

        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 1.5 }}>
          <NotificationsActiveRoundedIcon fontSize="small" sx={{ color: "text.secondary" }} />
          <Typography variant="caption" color="text.secondary">
            Each employee belongs to one visit role. Supervisors approve in order, and the last one's approval makes the visit ready for payment.
          </Typography>
        </Stack>

        <Box sx={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            getRowId={(r) => r.id}
            disableRowSelectionOnClick
            pageSizeOptions={[5, 10, 25]}
            initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 } } }}
            columns={columns}
            slots={{ noRowsOverlay: NoRows }}
            sx={{
              "& .MuiDataGrid-columnHeaders": { bgcolor: "rgba(0,150,136,0.06)" },
              "& .MuiDataGrid-row:hover": { background: "rgba(0,150,136,0.04)" },
              "& .MuiDataGrid-columnHeaderTitle": {          // ← header text centered
                width: "100%",
                textAlign: "center",
              },
              "& .MuiDataGrid-columnHeader": {                // ← header cell content centered
                display: "flex",
                justifyContent: "center",
              },
              "& .MuiDataGrid-cell": {                         // ← body cell content centered
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              borderColor: "#b2dfdb",
              borderRadius: 2,
            }}
          />
          
        </Box>
      </CardContent>
    </Card>

    
   {/* Create/Edit dialog */}
    <Dialog
      open={dialogOpen}
      onClose={closeDialog}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          bgcolor: "#ffffff",
          border: "1px solid",
          borderColor: "rgba(0,0,0,0.08)",
          boxShadow: "0 28px 80px rgba(0,0,0,.28)",
        },
      }}
    >
      <Box sx={{ height: 6, background: "linear-gradient(90deg, rgba(0,137,123,1) 0%, rgba(0,151,167,1) 100%)" }} />

      {formError && (
        <Alert severity="error" sx={{ m: 2, mb: 0, borderRadius: 2 }}>
          {formError}
        </Alert>
      )}

      <DialogTitle sx={{ pb: 1.25, pt: 2.25 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar
              sx={{
                bgcolor: "rgba(0,131,143,0.10)",
                color: "#006064",
                width: 48,
                height: 48,
                border: "1px solid rgba(0,131,143,0.25)",
              }}
            >
              <NotificationsActiveRoundedIcon/>
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 900, color: "#0f172a" }}>
                {dialogMode === "create" ? "Create visit role" : "Edit visit role"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Configure assigned employees and the supervisor approval chain.
              </Typography>
            </Box>
          </Stack>
          <Chip
            label={dialogMode === "create" ? "New" : "Editing"}
            sx={{
              fontWeight: 800,
              borderRadius: 2,
              bgcolor: dialogMode === "create" ? "rgba(0,137,123,0.10)" : "rgba(0,151,167,0.10)",
              color: dialogMode === "create" ? "#00695C" : "#006064",
              border: "1px solid rgba(0,0,0,0.06)",
            }}
          />
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 2.5 }}>
        <Stack spacing={2.25}>

          <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid rgba(0,0,0,0.08)", bgcolor: "rgba(2,132,199,0.02)" }}>
            <CardContent sx={{ p: 2.25 }}>
              <Stack spacing={1.75}>
                <Stack spacing={0.25}>
                  <Typography sx={{ fontWeight: 900, color: "#0f172a" }}>Basics</Typography>
                  <Typography variant="body2" color="text.secondary">
                    A name that tells HR which group this is.
                  </Typography>
                </Stack>
                <TextField
                  label="Visit role name"
                  required
                  value={visitName}
                  onChange={(e) => setVisitName(e.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2.25 } }}
                />
              </Stack>
            </CardContent>
          </Card>
          {/* <TextField
            label="Visit role name"
            required
            value={visitName}
            onChange={(e) => setVisitName(e.target.value)}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2.25 } }}
          /> */}

          {/* Section: Select the employee(s) */}
          <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid rgba(0,0,0,0.08)", bgcolor: "#ffffff" }}>
            <CardContent sx={{ p: 2.25 }}>
              <Stack spacing={1.75}>
                <Stack spacing={0.25}>
                  <Typography sx={{ fontWeight: 900, color: "#0f172a" }}>
                    Select the employee(s)
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    An employee can only be in one visit role at a time.
                  </Typography>
                </Stack>

                <Autocomplete
                  multiple
                  options={assignableEmployees}
                  value={selectedEmployees}
                  //disabled={dialogMode === "edit"}
                  getOptionLabel={empSearchLabel}
                  filterOptions={filterByNameOrCode}
                  renderOption={renderPickerOption}
                  isOptionEqualToValue={(a, b) => Number(a.empid) === Number(b.empid)}
                  onChange={(_, val) => setSelectedEmployees(val)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employees"
                      placeholder="Type name or code"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {/* {dialogMode === "create" && ( */}
                              <Tooltip title="Select all employees">
                                <IconButton
                                  size="small"
                                  onClick={() => setSelectedEmployees(assignableEmployees)}
                                  sx={{ mr: 0.5, bgcolor: "rgba(0,150,136,0.06)", "&:hover": { bgcolor: "rgba(0,150,136,0.12)" } }}
                                >
                                  <SelectAllIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            {/* )} */}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2.25 } }}
                    />
                  )}
                />
              </Stack>
            </CardContent>
          </Card>

          {/* Section: Select the supervisors, in priority order */}
          <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid rgba(0,0,0,0.08)", bgcolor: "#ffffff" }}>
            <CardContent sx={{ p: 2.25 }}>
              <Stack spacing={1.75}>
                <Stack spacing={0.25}>
                  <Typography sx={{ fontWeight: 900, color: "#0f172a" }}>
                    Supervisors & escalation
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Supervisors approve in this order. Use the arrows to change priority and set an escalation delay in days.
                  </Typography>
                </Stack>

                <Autocomplete
                  multiple
                  options={employees}
                  value={selectedSupervisors}
                  getOptionLabel={empSearchLabel}
                  filterOptions={filterByNameOrCode}
                  renderOption={renderPickerOption}
                  isOptionEqualToValue={(a, b) => Number(a.empid) === Number(b.empid)}
                  onChange={(_, val) => setSelectedSupervisors(val)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Supervisors"
                      placeholder="Type name or code"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <Tooltip title="Select all employees as supervisors">
                              <IconButton
                                size="small"
                                onClick={() => setSelectedSupervisors(employees)}
                                sx={{ mr: 0.5, bgcolor: "rgba(0,150,136,0.06)", "&:hover": { bgcolor: "rgba(0,150,136,0.12)" } }}
                              >
                                <SelectAllIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2.25 } }}
                    />
                  )}
                />

                {selectedSupervisors.length > 0 ? (
                  <Stack spacing={1.25} sx={{ mt: 0.5 }}>
                    {selectedSupervisors.map((sup, idx) => (
                      <Card
                        key={sup.empid}
                        elevation={0}
                        sx={{
                          borderRadius: 2.75,
                          border: "1px solid #e0f2f1",
                          bgcolor: "#ffffff",
                          px: 1.75,
                          py: 1.35,
                          transition: "0.2s",
                          "&:hover": { boxShadow: "0 6px 18px rgba(0,150,136,.12)", borderColor: "#80cbc4" },
                        }}
                      >
                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                          <Stack direction="row" spacing={1.5} alignItems="center">
                            <Avatar sx={{ width: 34, height: 34, bgcolor: "#00897B", color: "#ffffff", fontSize: 14, fontWeight: 900 }}>
                              {idx + 1}
                            </Avatar>
                            <Stack spacing={0.15}>
                              <Typography sx={{ fontWeight: 800, color: "#0f172a" }}>{sup.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                Employee #{sup.code || sup.empid}
                              </Typography>
                            </Stack>
                          </Stack>

                          <Stack direction="row" spacing={1} alignItems="center">
                            <TextField
                              size="small"
                              type="number"
                              label="Escalation delay"
                              value={Number(supervisorAfterDays?.[sup.empid] ?? 0)}
                              onChange={(e) => {
                                const n = Math.max(0, Number(e.target.value) || 0);
                                setSupervisorAfterDays((prev) => ({ ...prev, [sup.empid]: n }));
                              }}
                              InputProps={{ endAdornment: <InputAdornment position="end">days</InputAdornment> }}
                              inputProps={{ min: 0, step: 1 }}
                              sx={{ width: 170, "& .MuiOutlinedInput-root": { borderRadius: 2.25 } }}
                            />
                            <IconButton size="small" disabled={idx === 0} onClick={() => moveSupUp(idx)}>
                              <ArrowUpwardRoundedIcon fontSize="small" />
                            </IconButton>
                            <IconButton size="small" disabled={idx === selectedSupervisors.length - 1} onClick={() => moveSupDown(idx)}>
                              <ArrowDownwardRoundedIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                        </Stack>
                      </Card>
                    ))}
                  </Stack>
                ) : (
                  <Box sx={{ p: 2, borderRadius: 2.5, border: "1px dashed rgba(0,0,0,0.18)", bgcolor: "rgba(0,0,0,0.02)" }}>
                    <Typography variant="body2" color="text.secondary">
                      No supervisors selected yet. Add at least one to enable approvals.
                    </Typography>
                  </Box>
                )}
              </Stack>
            </CardContent>
          </Card>

        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2.25,
          bgcolor: "rgba(0,0,0,0.02)",
          borderTop: "1px solid rgba(0,0,0,0.06)",
          justifyContent: "space-between",
        }}
      >
        <Button onClick={closeDialog} variant="text" color="inherit" sx={{ fontWeight: 800 }}>
          Cancel
        </Button>
        <LoadingButton
          loading={saving}
          onClick={saveAssignment}
          variant="contained"
          sx={{
            borderRadius: 2.25,
            px: 2.25,
            bgcolor: "#0f766e",
            ":hover": { bgcolor: "#0b5f59" },
            boxShadow: "0 10px 24px rgba(15,118,110,.24)",
            fontWeight: 900,
          }}
        >
          {dialogMode === "create" ? "Create visit role" : "Save changes"}
        </LoadingButton>
      </DialogActions>
    </Dialog>

    {/* Delete confirm */}
    <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle>Delete visit role?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            {`"${deletingRole?.visitName || ""}" will be deleted, and its ${deletingRole?.empIds?.length || 0} employee(s) will have no visit approvers until you add them to another role.`}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <LoadingButton color="error" variant="contained" loading={deleting} onClick={confirmDelete}>
            Delete
          </LoadingButton>
      </DialogActions>
    </Dialog>

    <Snackbar open={snack.open} autoHideDuration={3000} onClose={() => setSnack((s) => ({ ...s, open: false }))}>
      <Alert severity={snack.severity} variant="filled" sx={{ width: "100%" }}>
        {snack.message}
      </Alert>
    </Snackbar>
  </Box>
);
      
        
    
}